var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"title-header"},[_c('div',{staticClass:"backdrop"},[_c('h2',[_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }